import * as React from 'react';

function SvgAttachment(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask id="Attachment_svg__a" fill="#fff">
        <path d="M11.097 20.448l8.7-8.64c.73-.725.73-1.9 0-2.625a1.878 1.878 0 00-2.64-.004L6.862 19.355a2.89 2.89 0 00-.006 4.111 2.937 2.937 0 004.134 0L21.851 12.68a3.894 3.894 0 000-5.534 3.959 3.959 0 00-5.572 0l-9.702 9.636" />
      </mask>
      <path
        d="M19.797 11.808l-.564-.568.564.568zm0-2.625l.563-.568-.563.568zm-2.64-.004l-.562-.57v.001l.563.57zM6.862 19.355l.562.569-.562-.57zm-.006 4.111l-.564.568.564-.567zm4.134 0l-.563-.567.563.567zM21.851 12.68l-.564-.568.564.568zM16.28 7.146l-.563-.568.563.568zm-4.618 13.87l8.7-8.64-1.128-1.136-8.7 8.64 1.128 1.135zm8.7-8.64a2.648 2.648 0 000-3.76L19.232 9.75a1.048 1.048 0 010 1.49l1.127 1.135zm0-3.76a2.678 2.678 0 00-3.766-.006l1.125 1.138a1.078 1.078 0 011.513.003l1.127-1.136zm-3.766-.006L6.3 18.786l1.124 1.138L17.72 9.748 16.595 8.61zM6.3 18.785a3.69 3.69 0 00-.008 5.25l1.128-1.136a2.09 2.09 0 01.004-2.975L6.3 18.785zm-.008 5.25a3.737 3.737 0 005.262 0l-1.127-1.136a2.137 2.137 0 01-3.007 0l-1.128 1.135zm5.262 0l10.86-10.788-1.127-1.135L10.427 22.9l1.127 1.135zm10.86-10.788a4.694 4.694 0 000-6.669l-1.127 1.136a3.094 3.094 0 010 4.398l1.128 1.135zm0-6.669a4.759 4.759 0 00-6.698 0l1.127 1.136a3.159 3.159 0 014.444 0l1.128-1.136zm-6.698 0l-9.702 9.637L7.14 17.35l9.702-9.636-1.127-1.136z"
        fill="#414B56"
        mask="url(#Attachment_svg__a)"
      />
    </svg>
  );
}

export default SvgAttachment;
